import { render } from "./ButtonBilling.vue?vue&type=template&id=2819ffdc"
import script from "./ButtonBilling.vue?vue&type=script&lang=js"
export * from "./ButtonBilling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__